import React from "react";
import { Path } from "enums";
import { Route, Switch, Redirect } from "react-router-dom";
import CashInModule from "modules/plc/cashin/cashin.module";

const PLCCashInPage = () => {
  return (
    <Switch>
      <Route exact path={Path.PLCCashIn} component={CashInModule} />
      <Redirect to={Path.PLCCashIn} />
    </Switch>
  );
};

export default PLCCashInPage;
